module.exports = __webpack_public_path__ + "img/logo.9c1cd0fc.png";